import { Discount } from "@mui/icons-material";
import DiscountCouponCreate from "./DiscountCouponCreate";
import DiscountCouponEdit from "./DiscountCouponEdit";
import DiscountCouponList from "./DiscountCouponList";
import DiscountCouponShow from "./DiscountCouponShow";

const discountCoupons = {
  list: DiscountCouponList,
  create: DiscountCouponCreate,
  show: DiscountCouponShow,
  edit: DiscountCouponEdit,
  icon: Discount,
};

export default discountCoupons;
